import styled, { css } from 'styled-components';

import { Button as commonButton } from '../../assets/Common/Button.style';

import { Strong as commonStrong } from '../../assets/Common/Strong.style';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
`;

export const Box = styled.div`
  display: grid;
  width: 100%;
  grid-gap: 50px;
`;

export const Panel = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 25px;
  margin: auto;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  box-shadow: 0 3px 10px 0 ${(props) => props.theme.shadow};
`;

export const Header = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 25px;
`;

export const Title = styled.h3`
  display: inline-block;
  color: ${(props) => props.theme.color};
  font-size: 26px;
  font-weight: 400;
  text-align: center;
  cursor: default;
`;

export const Category = styled.span`
  ${commonStrong}
  color: ${(props) => props.theme.color};
`;

export const Deco = styled.span`
  ${commonStrong}
  color: ${(props) => props.theme.color};
`;

export const Table = styled.div`
  display: grid;
  width: 100%;
  grid-gap: 5px;
`;

export const Row = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(7, 1fr);
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  box-shadow: 0 3px 10px 0 ${(props) => props.theme.shadow};

  ${(props) =>
    props.head &&
    css`
      border-radius: 0;
    `}
`;

export const Cell = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  padding: 15px;
  color: ${(props) => props.theme.color};
  font-size: 17px;
  font-weight: 400;
  line-height: 1;
  cursor: default;

  ${(props) =>
    props.head &&
    css`
      padding: 10px 15px;
      border-radius: 0;
      font-weight: 700;
    `}

  ${(props) =>
    props.right &&
    css`
      justify-content: flex-end;
    `}
`;

export const Button = styled.button`
  ${commonButton}
`;

export const ButtonIcon = styled.i``;
